module.exports = __webpack_public_path__ + "static/media/5DPO7.69826263.jpg";